import React, {Component} from 'react';
import ProjectList from "./ProjectList";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import SaveIcon from '@material-ui/icons/Save';
import CalculateAreaCoveragePathsForm from "./areacoverage/CalculateAreaCoveragePathsForm";
import CalculateScatteredRegionsVisitationPathsForm
    from "./scatteredregionsvisitation/CalculateScatteredRegionsVisitationPathsForm";
import Tooltip from "@material-ui/core/Tooltip";
import DeploymentAreaCoverageForm from "./DeploymentAreaCoverageForm";

const steps = ['Select Project', 'Calculate Paths', 'Deploy']

class Sidebar extends Component {

    state = {
        activeStep: 0
    }

    handleBack = () => {

        if (this.state.activeStep === 1) {
            this.props.getProjects();

        }

        if (this.state.activeStep === 2) {
            this.props.setEditingPolygons(true)

        }

        this.setState({
            activeStep: this.state.activeStep - 1
        })
    }

    handleNext = () => {

        if (this.state.activeStep === 1) {
            this.props.setEditingPolygons(false)
            this.props.calculateEstimatedDeploymentTime();
        }
        this.setState({
            activeStep: this.state.activeStep + 1
        })

    }

    handleNewPoject = (type) => {
        this.handleNext();

        this.props.onNewProject(type);
    }

    render() {

        const {activeStep} = this.state;

        return (
            <div>
                <Stepper style={{marginTop: '10px', marginBottom: '10px'}} activeStep={activeStep} alternativeLabel>
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                {activeStep === 0 ?
                    <div style={{'display': 'flex', 'flex-direction': 'column', 'justify-content': 'space-between'}}>


                        <ProjectList projects={this.props.projects}
                                     handleNewPoject={this.handleNewPoject}
                                     onClickProject={(project) => {
                                         this.handleNext();
                                         this.props.onClickProject(project);
                                     }}/>


                    </div>
                    : activeStep === 1 ? this.props.selectedProjectType === 'AREA_COVERAGE' ?
                        <div>
                            <Paper style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                marginTop: '10px',
                                marginBottom: '10px'
                            }}>
                                <Tooltip title="save first to keep changes" placement="top">
                                    <Button style={{margin: '5px'}} variant="outlined" onClick={this.handleBack}>
                                        <ArrowBackIcon/>
                                        Back
                                    </Button>
                                </Tooltip>


                                <Button style={{margin: '5px'}} variant="outlined" onClick={this.props.onSaveAreaCoverageProject}>
                                    <SaveIcon/>
                                    Save
                                </Button>

                                {this.props.project.id && this.props.project.areaCoveragePaths.length > 0 ?
                                    <Button style={{margin: '5px'}} variant="outlined" onClick={this.handleNext}>
                                        <ArrowForwardIcon/>
                                        Next
                                    </Button> :

                                    <Tooltip
                                        title={this.props.project.areaCoveragePaths.length === 0 ? "calculate paths first!" : "project must be saved first!"}
                                        placement="top">
                                        <div>
                                            <Button disabled={true} style={{margin: '5px'}} variant="outlined"
                                                    onClick={this.handleNext}>
                                                <ArrowForwardIcon/>
                                                Next
                                            </Button>
                                        </div>
                                    </Tooltip>}
                            </Paper>
                            <CalculateAreaCoveragePathsForm
                                project={this.props.project}
                                onPortionsChange={this.props.onPortionsChange}
                                onResetPortions={this.props.onResetPortions}
                                calculatePathsFormErrors={this.props.calculatePathsFormErrors}
                                numberOfDronesChangeLoading={this.props.numberOfDronesChangeLoading}
                                onNumberOfDronesChange={this.props.onNumberOfDronesChange}
                                onProjectChange={this.props.onProjectChange}
                                onProjectCheckboxChange={this.props.onProjectCheckboxChange}
                                onResetRegionOfInterest={this.props.onResetRegionOfInterest}
                                onExecuteCalculatePathsClick={this.props.onExecuteAreaCoverageCalculatePaths}
                                onExecuteTreeadsPathsClick={this.props.onExecuteTreeadsPathsClick}
                                onCancelDarpClick={this.props.onCancelDarpClick}
                                onAddNoFlyZoneClick={this.props.onAddNoFlyZoneClick}
                                darpLoading={this.props.darpLoading}
                                dronesSubscribed={this.props.dronesSubscribed}
                            /></div> :
                        <div>
                            <Paper style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                marginTop: '10px',
                                marginBottom: '10px'
                            }}>
                                <Tooltip title="save first to keep changes" placement="top">
                                    <Button style={{margin: '5px'}} variant="outlined" onClick={this.handleBack}>
                                        <ArrowBackIcon/>
                                        Back
                                    </Button>
                                </Tooltip>


                                <Button style={{margin: '5px'}} variant="outlined" onClick={this.props.onSaveScatteredRegionsVisitationProject}>
                                    <SaveIcon/>
                                    Save
                                </Button>

                                {this.props.project.id && this.props.project.scatteredRegionsVisitationPaths.length > 0 ?
                                    <Button style={{margin: '5px'}} variant="outlined" onClick={this.handleNext}>
                                        <ArrowForwardIcon/>
                                        Next
                                    </Button> :

                                    <Tooltip title={this.props.project.scatteredRegionsVisitationPaths.length === 0 ? "calculate paths first!" : "project must be saved first!"} placement="top">
                                        <div>
                                            <Button disabled={true} style={{margin: '5px'}} variant="outlined"
                                                    onClick={this.handleNext}>
                                                <ArrowForwardIcon/>
                                                Next
                                            </Button>
                                        </div>
                                    </Tooltip>}
                            </Paper>
                            <CalculateScatteredRegionsVisitationPathsForm
                                project={this.props.project}
                                calculatePathsFormErrors={this.props.calculatePathsFormErrors}
                                onProjectChange={this.props.onProjectChange}
                                onProjectCheckboxChange={this.props.onProjectCheckboxChange}
                                onResetRegionOfInterest={this.props.onResetRegionOfInterest}
                                onExecuteScatteredRegionsCalculatePaths={this.props.onExecuteScatteredRegionsCalculatePaths}
                                executeScatteredRegionsLoading={this.props.executeScatteredRegionsLoading}
                                onAddPolygonClick={this.props.onAddPolygonClick}
                                dronesSubscribed={this.props.dronesSubscribed}
                                droneCanonicalNames={this.props.droneCanonicalNames}
                                dronesConfig={this.props.dronesConfig}
                            /></div> : activeStep === 2 ?
                        <div>
                            <Paper style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                marginTop: '10px',
                                marginBottom: '10px'
                            }}>
                                {this.props.deploymentStatus === 'ONGOING' ?
                                    <Tooltip title="deployment is running!" placement="top">
                                        <div>
                                            <Button disabled={true} style={{margin: '5px'}} variant="outlined"
                                                    onClick={this.handleBack}>
                                                <ArrowBackIcon/>
                                                Back
                                            </Button>
                                        </div>
                                    </Tooltip> :
                                    <Button style={{margin: '5px'}} variant="outlined" onClick={this.handleBack}>
                                        <ArrowBackIcon/>
                                        Back
                                    </Button>}

                            </Paper>
                            <DeploymentAreaCoverageForm
                                estimatedDeploymentTime={this.props.estimatedDeploymentTime}
                                droneCanonicalNames={this.props.droneCanonicalNames}
                                project={this.props.project}
                                deploymentAreaCoverageForm={this.props.deploymentAreaCoverageForm}
                                onDeploymentAreaCoverageFormChange={this.props.onDeploymentAreaCoverageFormChange}
                                deploymentAreaCoverageFormErrors={this.props.deploymentAreaCoverageFormErrors}
                                onStartDeployment={this.props.onStartDeployment}
                                onAbortDeployment={this.props.onAbortDeployment}
                                dronesSubscribed={this.props.dronesSubscribed}
                                dronesLive={this.props.dronesLive}
                                dronesConfig={this.props.dronesConfig}
                                droneStatuses={this.props.droneStatuses}
                                runDeploymentButtonDisabled={this.props.runDeploymentButtonDisabled}
                                deploymentStatus={this.props.deploymentStatus}
                            />
                        </div> : null}
            </div>

        )
    }
}

export default Sidebar;
